/**
 * axios setup to use mock service
 */

import axios from "axios";

const axiosServices = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3010/",
});
export default axiosServices;
